"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitAction = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var Action_1 = require("./Action");
var WaitAction = (function (_super) {
    tslib_1.__extends(WaitAction, _super);
    function WaitAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WaitAction_1 = WaitAction;
    WaitAction.prototype.execute = function (ms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
            });
        });
    };
    WaitAction.ms = function (ms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, new WaitAction_1().run(ms)];
            });
        });
    };
    WaitAction.sec = function (sec) {
        if (sec === void 0) { sec = 1; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, new WaitAction_1().run(sec * 1000)];
            });
        });
    };
    WaitAction.frame = function (frames) {
        if (frames === void 0) { frames = 1; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(--frames >= 0)) return [3, 2];
                        return [4, new Promise(function (resolve) { return requestAnimationFrame(resolve); })];
                    case 1:
                        _a.sent();
                        return [3, 0];
                    case 2: return [2];
                }
            });
        });
    };
    var WaitAction_1;
    WaitAction = WaitAction_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], WaitAction);
    return WaitAction;
}(Action_1.Action));
exports.WaitAction = WaitAction;
//# sourceMappingURL=WaitAction.js.map